import {settings} from "@/settings";
import {api} from "@/auth/api";
import {
    ActionType,
    GatheringProcess,
    Offer,
    receivedFile,
    RequiredDocumentType, RequiredDocumentTypeResponse,
    supportingDocuments,
    Task,
    TaskExecuteAction
} from "@/types";
import {executeTask} from "../workflow";
import store from "@/store";
import Notify from 'quasar/src/plugins/Notify.js';;
import i18n from "@/i18n";
import {headers} from "@/utils";
import axios from "axios";
import { getOrderOrchestration } from "../../order/orderApi";
import { removeBusinessData } from "../../order/commission/commissionService";
import { updateStatusReceivedFile } from "@/commons/gathering-process";
import moment from "moment";

const odm_offer = 'odm-offer'
const odm_supportingdocument = 'odm-supportingdocument'
const odmOrchestration = 'odm-orchestration'

/**
 * Service providing task/order document retrieval and validation helpers.
 */

/**
 * Retrieves gathering process data linked to an offer.
 *
 * @param entityId - Offer resource identifier
 * @returns Offer-related gathering process payload
 */
export const getOfferDocument = async (entityId: any) => {
const baseUrl = `${settings.api_url}/${odm_offer}/api/1/${odm_offer}`
return new Promise<any>(async (resolve, reject) => {
try {
const result = await api().get(`${baseUrl}/offer/` + entityId + '/associatedgatheringprocess/')
resolve(result.data)
        } catch (e) {
            reject(e)
        }
    });
}

/**
 * Retrieves required document types for one process.
 *
 * @param processId - Supporting-document process identifier
 * @returns Required document type list for the process
 */
export const getRequiredDocument = async (processId: any) => {
    const baseUrl = `${settings.api_url}/${odm_supportingdocument}/api/1/${odm_supportingdocument}/`
    return new Promise<any>(async (resolve, reject) => {
        try {
            const result = await api().get(`${baseUrl}process/` + processId + '/requiredDocumentType/')
            resolve(result.data)
        } catch (e) {
            reject(e)
        }
    });
}
export const getRequiredDocumentValidatedByBR = async (processId: any,orderId:any,module?:any) => {
    const baseUrl = `${settings.api_url}/${odm_supportingdocument}/api/1/${odm_supportingdocument}/`
    let order

    if(module==='orderModule'){
         order=store.state.orderModule.order
    }else if(module==='taskModule'){
        order=store.state.taskModule.order
    }else if(module==='summaryPanelModule'){
        order=store.state.summaryPanelModule.order
    }else{
        order = await getOrderOrchestration(orderId)
    }

    if (!order) {
            order = await getOrderOrchestration(orderId)
    }
    order.connectedUser = getRoleUser();
    removeBusinessData(order)
    const body={orderInfo:JSON.stringify(order)}

    return new Promise<any>(async (resolve, reject) => {
        try {
            const result = await api().post(`${baseUrl}process/` + processId + '/requiredDocumentTypeValidatedByBR/',body)
            resolve(result.data)
        } catch (e) {
            reject(e)
        }
    });
}


export const getRequiredDocumentValidatedByBRBatch = async (
    processIds: string[],
    orderId: string,
    module?: string,
    reevaluate = false
): Promise<Record<string, any[]>> => {
    const baseUrl = `${settings.api_url}/${odm_supportingdocument}/api/1/${odm_supportingdocument}/batch-process/`

    let order
    if (module === 'orderModule') {
        order = store.state.orderModule.order
    } else if (module === 'taskModule') {
        order = store.state.taskModule.order
    } else if (module === 'summaryPanelModule') {
        order = store.state.summaryPanelModule.order
    } else {
        order = await getOrderOrchestration(orderId)
    }

    if (!order) {
        order = await getOrderOrchestration(orderId)
    }

    order.connectedUser = getRoleUser()
    removeBusinessData(order)

    const body = {
        processIds,
        orderInfo: JSON.stringify(order),
        reevaluate
    }

    const result = await api().post(`${baseUrl}requiredDocumentTypeValidatedByBR/`, body)
    return result.data
}


export const getRequiredDocumentBatch = async (
    processIds: string[]
): Promise<Record<string, any[]>> => {
    const baseUrl = `${settings.api_url}/${odm_supportingdocument}/api/1/${odm_supportingdocument}/batch-process/`

    const body = { processIds }

    const result = await api().post(`${baseUrl}requiredDocumentType/`, body)
    return result.data
}

function getRoleUser(){
  const connectedUser = store.getters["authModule/getUserConnected"];
  const userConnectedFromLocalStorage =  store.getters["authModule/getUserConnectedFromLocalStorage"]
  const user = connectedUser?.userId ? connectedUser : userConnectedFromLocalStorage
  return {
    isSecretary: user.authorities?.some((el: { authority: string }) => ["ROLE_SECRETARY", "ROLE_ASS_COMM", "ROLE_LIV"].includes(el.authority)) || false,
    isAssistant: user.authorities?.some((el: { authority: string }) => el.authority === "ROLE_ASSISTANT") || false,
    isAgent: user.authorities?.some((el: { authority: string }) => el.authority === "ROLE_AGENT") || false,
    isCDV: user.authorities?.some((el: { authority: string }) => el.authority === "ROLE_CDV") || false,
    isSales: user.authorities?.some((el: { authority: string }) => el.authority === "ROLE_SALES") || false,
    isPrepateur: user.authorities?.some((el: { authority: string }) => el.authority === "ROLE_PREPATEUR") || false,
    isMetteurEnMain: user.authorities?.some((el: { authority: string }) => el.authority === "ROLE_METTEUR") || false,
    isAuditor: user.authorities?.some((el: { authority: string }) => el.authority === "ROLE_AUDITORS") || false,
  };
}
export const getProcess = async (processId: any) => {
    const baseUrl = `${settings.api_url}/${odm_supportingdocument}/api/1/${odm_supportingdocument}/`
    return new Promise<GatheringProcess>( async (resolve, reject) => {
        try {
            const result = await api().get(`${baseUrl}process/` + processId + '/')
            resolve(result.data)
        } catch (e) {
            reject(e)
        }
    });
}
export const getProcessOrch = async (processId: any,orderId:any,requiredDocuments: any) => {
    const baseUrl = `${settings.api_url}/${odmOrchestration}/business-api/1/`
    return new Promise<GatheringProcess>( async (resolve, reject) => {
        try {
            const result = await api().post(`${baseUrl}process/` + processId + '/' + orderId + '/',requiredDocuments)
            resolve(result.data)
        } catch (e) {
            reject(e)
        }
    });
}

export const receiveFile = async (processId: any, docId: any, file: any) => {
    const baseUrl = `${settings.api_url}/${odm_supportingdocument}/api/1/${odm_supportingdocument}/`
    const url = `${baseUrl}/process/${processId}/document/${docId}/file/`;
    const body = file
    return new Promise<receivedFile>(async (resolve, reject) => {
        try {
            const result = await api().post(url, body)
            resolve(result.data)
        } catch (e) {
            reject(e)
        }
    });
}
export const qualifyFile = async (processId: any, docId: any, fileId: any, file: any) => {
    const baseUrl = `${settings.api_url}/${odm_supportingdocument}/api/1/${odm_supportingdocument}/`
    const url = `${baseUrl}/process/${processId}/document/${docId}/file/${fileId}/qualification/`;

    const body = file
    return new Promise<receivedFile>(async (resolve, reject) => {
        try {
            const result = await api().post(url, body)
            resolve(result.data)
        } catch (e) {
            reject(e)
        }
    });
}
export const manualAddDocument = async (processId: any, file: any) => {
    const baseUrl = `${settings.api_url}/${odm_supportingdocument}/api/1/${odm_supportingdocument}/`
    const body = file
    return new Promise<any>(async (resolve, reject) => {
        try {
            const result = await api().post(`${baseUrl}/process/` + processId + `/supporting/`, body)
            resolve(result.data)
        } catch (e) {
            reject(e)
        }
    });
}
export const sendToControl = async (processId: any) => {
    const baseUrl = `${settings.api_url}/${odm_supportingdocument}/api/1/${odm_supportingdocument}`

    return new Promise<any>(async (resolve, reject) => {
        try {
            const result = await api().put(`${baseUrl}/process/` + processId + `/control/`, {})
            resolve(result.data)
        } catch (e) {
            reject(e)
        }
    });
}
export async function executeUploadDocumentAction(task: Task) {

    const qualified = i18n.global.t(`task.uploadDocument.headers.supportingDocumentStatus.QUALIFIED`);
    const valid = i18n.global.t(`task.uploadDocument.headers.supportingDocumentStatus.VALID`);

    const gatheringProcess = store.state.taskModule.gatheringProcess;

    const validation = gatheringProcess
        .flatMap((gp: any) => gp.entityTargets)
        .flatMap((targetEntity: any) => targetEntity.documents)
        .some((doc: any) => doc.status !== qualified || doc.status !== 'QUALIFIED' || doc.status !== valid || doc.status !== 'VALID');

       let   validationFILE =true
       for (const gp of gatheringProcess) {
         for (const targetEntity of gp.entityTargets) {
            for ( const doc of targetEntity.documents ) {
             if (Object.keys(doc.document).length === 0  || doc.document.originalFileName === null) {
                    validationFILE= false
                    break;
                }
            }
        }
    }

    if (validation && validationFILE) {
        const sentToControl: string[] = []
        for (const gp of gatheringProcess) {
            for (const targetEntity of gp.entityTargets) {
                for ( const doc of targetEntity.documents ) {
                    if (sentToControl.indexOf(doc.processResourceUid) < 0) {
                        await store.dispatch('taskModule/uploadDocumentModule/sendToControl', {
                            resourceUid: doc.processResourceUid,
                        });
                        sentToControl.push(doc.processResourceUid)
                        Notify.create({
                            message: `Success!`,
                            color: 'positive'
                        });
                    }
                }
            }
        }

        const taskExecuteAction: TaskExecuteAction = {
            taskId: task.taskId || "",
            variables: {},
        };

        try {
            return executeTask(taskExecuteAction);
        } catch (e) {
            console.error(e);
            return Promise.reject(e);
        }
    } else {
        Notify.create({
            color: 'negative',
            message: 'List incomplete’'
        });
    }

    return validation;
}

export const getRequiredDocumentModifyCondition = async (processId: any) => {
    const requiredDocumentTypeList: RequiredDocumentType[] = []
    return new Promise<RequiredDocumentType[]>(async (resolve, reject) => {
        const qc_header: any = {
            qc: {
                queryId: 'supportingdocument-required-document-type',
                offset: 0,
                limit: 1000000,
            }
        }
        qc_header.qc.parameters = {
            process_id: processId
        }

        const _headers = headers({
            qc: JSON.stringify(qc_header.qc)
        })
        axios.get(settings.api_query_url, {
            headers: _headers
        }).then(res => {
            if (res.data.length) {

                res.data.forEach((item: RequiredDocumentTypeResponse) => {

                    let requiredDocumentType: RequiredDocumentType = {
                        resourceUid: item.doc_type_id,
                        objectType: 'odm.supportingdocument.documenttype',
                        systemUid: 'odm-supportingdocument',
                        businessData: null,
                        daaq: '/',
                        supportingType: [
                            {
                                resourceUid: item.supporting_type_id,
                                objectType: 'odm.supportingdocument.supportingtype',
                                systemUid: 'odm-supportingdocument',
                                businessData: null,
                                daaq: '/',
                                proofLevel: item.proof_level ? +item.proof_level : 0,
                                manual: item.manual === 'true' ? true : false,
                                supportingDocument: {
                                    objectType: 'odm.supportingdocument.supportingdocumentfamily',
                                    systemUid: 'odm-supportingdocument',
                                    resourceUid: item.supporting_document_code,
                                },
                            }]
                    }
                    requiredDocumentTypeList.push(requiredDocumentType)
                })

                resolve(requiredDocumentTypeList)
            } else {
                reject('error get email sales person')
            }
        }).catch(err => reject(err))
    })
}

export async function forceDocument(document: any,receivedComment: any,status: any) {
    let response = {
        receivedFilesUid: '',
        originalFileName: '',
        isForcedDocument : status === 'OVERWRITE' ? true : false,
        isCommentedDocument : status === 'COMMENTED' ? true : false
    }
  try {
    const process = await getProcess(document.processResourceUid)

    if (!process || !process.gatheringProcessItem) {
      throw new Error("Aucun gatheringProcessItem trouvé pour ce process")
    }

    const authName = store.getters["authModule/getAuthName"]

    for (const element of process.gatheringProcessItem) {
      const file = {
        fileReference: null,
        creationUser: authName,
        creationLabel: '',
        qualification: [
          {
            documentType: {
              resourceUid: document.documentType
            },
            label: ''
          }
        ],
        targetEntityId: document?.targetEntity?.resourceUid,
        systemUid: 'odm-supportingdocument',
         receivedComment: receivedComment || ''
      }

      const received = await receiveFile(document.processResourceUid, element.resourceUid, file)
      const statusBody = {
        status: {
          objectType: "odm.supportingdocument.receivedfilestatus",
          systemUid: "odm-supportingdocument",
          resourceUid: status
        }
      }
      if (received){
        response.receivedFilesUid = received.resourceUid
        await updateStatusReceivedFile(statusBody, received.resourceUid)
      }

    }
    Notify.create({
        message: status === 'OVERWRITE' ? "Document forcé avec succès" : "Document Commenté avec succès",
        color: "positive",
    })
    return response


  } catch (error: any) {
    console.error("Erreur dans forceDocument :", error)
    return { success: false, error: error.message }
  }
}
function intiValidity(body: any) {
  body.validity = {
    from: null,
    until: null
  }
}

export function normalizeSupportingType(requiredDocuments: any) {
  if (!requiredDocuments || requiredDocuments.length === 0) return

  for (const doc of requiredDocuments) {
    if (doc?.supportingType && doc.supportingType.length > 0) {
      for (const supportingType of doc.supportingType) {

        if (!supportingType.validity) {
          intiValidity(supportingType)
        } else {
            supportingType.validity.from ? console.log("supportingType.validity.from") : null
          supportingType.validity = {
            from: supportingType.validity.from
              ? moment(supportingType.validity.from, 'DD/MM/YYYY').format('YYYY-MM-DD')
              : null,
            until: supportingType.validity.until
              ? moment(supportingType.validity.until, 'DD/MM/YYYY').format('YYYY-MM-DD')
              : null,
          }
        }

      }
    }
  }
}
